import { Link } from "react-router-dom"

export default function Error() {
  return (
    <>
      <section className="flex flex-col items-center justify-center text-center pt-10 md:pt-20 lg:pt-36 px-5 2xl:px-0">
        <h1 className="mb-5">Error 404 | Page Not Found</h1>
        <p className="mb-10">
          Sorry, the page you are looking for does not exist or may have moved.
        </p>
        <Link to="/" className="btn-blue">
          Back to Homepage
        </Link>
      </section>
    </>
  )
}
